var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerksCake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.756 17.814H8.876a7.943 7.943 0 00-5.698 2.434 8.434 8.434 0 00-2.36 5.871v31.133c0 .33.063.657.186.963.122.305.302.582.53.815.226.233.495.419.791.545.297.126.614.19.935.19h55.115c.321 0 .639-.064.935-.19.296-.127.565-.312.792-.545a2.52 2.52 0 00.53-.815 2.58 2.58 0 00.186-.963V26.12c0-1.09-.209-2.17-.614-3.178a8.326 8.326 0 00-1.748-2.694 8.05 8.05 0 00-2.615-1.8 7.856 7.856 0 00-3.085-.633zm6.414 39.438a.83.83 0 01-.234.577.783.783 0 01-.56.238H3.26a.783.783 0 01-.56-.238.83.83 0 01-.234-.577V26.12a6.717 6.717 0 011.879-4.669 6.326 6.326 0 014.53-1.938h43.881c1.7.002 3.33.698 4.533 1.937a6.717 6.717 0 011.88 4.67v31.133z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.17 26.12v5.252c-3.563.157-5.481 1.987-7.185 3.61-1.704 1.623-3.329 3.168-6.572 3.168s-4.858-1.538-6.568-3.168c-1.783-1.698-3.804-3.623-7.69-3.623-3.885 0-5.906 1.925-7.689 3.623-1.71 1.63-3.328 3.168-6.568 3.168-3.24 0-4.858-1.538-6.572-3.168-1.78-1.698-3.8-3.623-7.686-3.623a.745.745 0 00-.174.02v-5.26a6.717 6.717 0 011.879-4.668 6.326 6.326 0 014.53-1.939h43.881c1.7.002 3.33.699 4.533 1.938a6.717 6.717 0 011.88 4.67z",
    fill: "#FFEC0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.498 32.207a.862.862 0 01-.241.6.812.812 0 01-.583.25h-.504c-2.91.149-4.446 1.615-6.068 3.157-1.78 1.698-3.8 3.62-7.689 3.62-3.889 0-5.906-1.922-7.689-3.62-1.71-1.63-3.325-3.171-6.568-3.171-3.244 0-4.858 1.541-6.569 3.171-1.783 1.698-3.803 3.62-7.69 3.62-3.885 0-5.905-1.922-7.688-3.62-1.71-1.63-3.329-3.171-6.569-3.171a.82.82 0 01-.638-.318.865.865 0 010-1.062.822.822 0 01.638-.318c3.886 0 5.906 1.925 7.686 3.623 1.714 1.63 3.329 3.168 6.572 3.168s4.858-1.538 6.568-3.168c1.783-1.698 3.8-3.623 7.69-3.623 3.889 0 5.906 1.925 7.689 3.623 1.71 1.63 3.328 3.168 6.568 3.168 3.24 0 4.861-1.538 6.572-3.168 1.71-1.63 3.625-3.453 7.185-3.61h.504c.219 0 .428.09.583.25.154.158.241.374.241.6z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.385 8.952c0-.892-.703-1.616-1.57-1.616-.866 0-1.568.724-1.568 1.616v7.901c0 .893.702 1.617 1.569 1.617.866 0 1.569-.724 1.569-1.617v-7.9z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.628,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.655 5.696c0 .903-.824 1.64-1.84 1.64-1.014 0-1.838-.737-1.838-1.64v-.15A7.44 7.44 0 0130.806 1c1.084.974 1.572 2.533 1.8 4.353.026.112.039.227.049.343z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 1.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.252 8.952c0-.892-.702-1.616-1.569-1.616-.866 0-1.569.724-1.569 1.616v7.901c0 .893.703 1.617 1.57 1.617.866 0 1.568-.724 1.568-1.617v-7.9z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.628,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.526 5.696c0 .903-.824 1.64-1.84 1.64-1.014 0-1.838-.737-1.838-1.64v-.15A7.422 7.422 0 0145.68 1c1.081.974 1.569 2.533 1.8 4.353l.046.343z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 1.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.517 8.952c0-.892-.702-1.616-1.568-1.616-.867 0-1.57.724-1.57 1.616v7.901c0 .893.703 1.617 1.57 1.617.866 0 1.568-.724 1.568-1.617v-7.9z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.628,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.788 5.696c0 .903-.824 1.64-1.84 1.64-1.014 0-1.838-.737-1.838-1.64v-.15A7.44 7.44 0 0115.942 1c1.084.974 1.572 2.533 1.8 4.353.02.112.036.227.046.343z",
    fill: "#FFEC0F",
    stroke: "#000",
    strokeWidth: 1.628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPerksCake;